<template>
<div class="wn-filter-trigger" :class="{ 'is-pressed': pressed, 'is-disabled': disabled }">
    <button type="button" class="wn-filter-trigger__button" :disabled="disabled" :aria-pressed="pressed" @click="$emit('click')">
        <i class="ri-filter-3-line"></i>
        <span>{{ label || $_locale('filter') }}</span>
    </button>
    <template v-if="count > 0">
        <span class="wn-badge" :aria-label="count">{{ count }}</span>
        <button type="button" class="wn-filter-trigger__clear" :title="$_locale('clear filter')" @click.stop="$emit('clear')">
            <i class="ri-close-circle-fill"></i>
        </button>
    </template>
</div>
</template>

<script>
export default {
    name: 'WnFilterTrigger',
    props: {
        label: { type: String, default: '' },
        count: { type: Number, default: 0 },
        pressed: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    emits: ['click', 'clear'],
}
</script>
